window.ThemeMotion = {
  preset: 'balanced',
  presets: {
    calm: {
      gsapDurationScale: 0.9,
      gsapDistanceScale: 0.75,
      gsapStaggerScale: 0.85,
    },
    balanced: {
      gsapDurationScale: 1,
      gsapDistanceScale: 1,
      gsapStaggerScale: 1,
    },
    expressive: {
      gsapDurationScale: 1.12,
      gsapDistanceScale: 1.2,
      gsapStaggerScale: 1.15,
    },
  },
};
